import { useUserContext } from 'common/contexts/UserContext';
import { useRegion } from 'common/hooks/region';
import PerDiemDownloadModal from 'components/PerDiemDownloadModal';
import { usePerDiemParams } from 'pages/PerDiemArchive/params';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ContainerTypeQueryKeys, fetchContainerTypes } from 'services/clients/containerType';
import { fetchShippingLines, ShippingLineQueryKeys } from 'services/clients/shippingLine';
import { getTeamMembers, UserQueryKeys } from 'services/clients/user';
import { DateSearchSpec } from '../selectors';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  search: DateSearchSpec | null;
}

export const LegacyPerDiemDownloadModal: React.FC<Props> = (props) => {
  const { isOpen, onClose, search } = props;

  const { searchParams } = usePerDiemParams();
  const emailsQuery = useQuery([UserQueryKeys.TeamMembers], ({ signal }) => getTeamMembers(signal));
  const region = useRegion();

  // Taking advantage of react-query's caching here since the dropdowns already got it
  const containerTypes = useQuery([ContainerTypeQueryKeys.ContainerTypes], ({ signal }) =>
    fetchContainerTypes({ signal })
  );
  const shippingLines = useQuery([ShippingLineQueryKeys.ShippingLines, region.code], ({ signal }) =>
    fetchShippingLines({ signal, portCollectionCodes: [region.code] })
  );

  const { user } = useUserContext();

  if (!search || !emailsQuery.data || !shippingLines.data || !containerTypes.data) {
    return null;
  }

  const shippingLineContainerTypes = [
    [
      shippingLines.data.find((sl) => sl.key === searchParams.shippingLine),
      containerTypes.data.find((c) => c.key === searchParams.container),
    ],
  ];

  return (
    <PerDiemDownloadModal
      feature="perDiemArchive"
      isOpen={isOpen}
      currentUser={user}
      emails={emailsQuery.data.map((e) => e.email)}
      handleOnClose={onClose}
      shippingLineContainerTypes={shippingLineContainerTypes}
      startDate={search.mode === 'date-range' ? search.startDate : search.date}
      time={search.mode === 'specific-date' ? search.time : ''}
      endDate={search.mode === 'date-range' ? search.endDate : null}
      selectedRange={searchParams.mode}
      modalType="perDiemArchive"
      portCollectionCode={region.code}
    />
  );
};
